import { safeGet, safeSet } from './local-storage.js';

// One-time nudge pointing at the setup screen's Computer toggle button, for
// whichever game actually supports CPU opponents (see games/shared/
// x01-game.js's own supportsCpuPlayers comment) - shown at most once ever
// (marked seen as soon as it's shown), and dismissed early the moment
// someone actually switches to Computer. Same pattern as core/menu.js's own
// one-time hint for the hamburger menu.
const CPU_HINT_STORAGE_KEY = 'halveren-cpu-hint-seen';

function hasSeenCpuHint() {
    return !!safeGet(CPU_HINT_STORAGE_KEY);
}

function markCpuHintSeen() {
    safeSet(CPU_HINT_STORAGE_KEY, '1');
}

export function dismissCpuHint() {
    const hint = document.getElementById('cpuHint');
    if (hint) hint.classList.remove('visible');
}

// Called every time the setup screen for a CPU-supporting game is shown -
// a no-op after the first time ever (hasSeenCpuHint), so switching between
// games or revisiting setup never shows it again.
export function maybeShowCpuHint() {
    if (hasSeenCpuHint()) return;
    const hint = document.getElementById('cpuHint');
    if (!hint) return;
    markCpuHintSeen();
    setTimeout(() => hint.classList.add('visible'), 500);
    setTimeout(() => dismissCpuHint(), 6500);
}
